export const capitalize = (str: string) =>
  str && typeof str === 'string'
    ? str.charAt(0).toUpperCase() + str.slice(1)
    : str;

export const toDashedCase = (str: string) => {
  return str
    .replace(
      /([a-z])(?=[A-Z])|([A-Z])(?=[A-Z][a-z])|([A-Za-z])(?=\d)/g,
      '$1$3-$2',
    )
    .toLowerCase();
};
